import { Divider, Stack } from '@mui/material';
import React, { Fragment, useEffect, useState } from 'react';
import { DateFilterValue, IDateFilter } from './interfaces';
import { DatePicker, RadioField } from '../../../forms';
import { useTranslation } from 'react-i18next';
import { IRadioOption } from '../../../forms/radio/RadioOption/interfaces';
import { DateFilterOptions } from '../../../ManagedDataTable/interfaces';
import dayjs from 'dayjs';
import { getOperatorFromOption, getOptionBasedOnOperator } from './helpers';
import { PeriodSelector } from './components/PeriodSelector';
import { Period } from './components/PeriodSelector/interfaces';

export const DateFilter: React.FC<IDateFilter> = ({
  label,
  value,
  onChange,
}): JSX.Element => {
  const { t } = useTranslation();
  const [selectedPeriod, setSelectedPeriod] = useState<Period | null>(() => {
    if (value?.length === 2) {
      return {
        from: dayjs(value[0].value as string),
        to: dayjs(value[1].value as string),
      };
    }

    return null;
  });
  const [selectedDate, setSelectedDate] = useState<dayjs.Dayjs | null>(
    (() => {
      if (value && value.length > 0) {
        return dayjs(value[0].value as string);
      }

      return null;
    })()
  );
  const [option, setOption] = useState<DateFilterOptions>(
    ((): DateFilterOptions => {
      if (value?.length === 1) {
        return getOptionBasedOnOperator(value[0].operator);
      } else if (value?.length === 2) {
        return 'between';
      }

      return 'all';
    })()
  );

  const showFromDatePicker = !['all', 'between'].includes(option);
  const showPeriodSelector = option === 'between';

  const options: IRadioOption<DateFilterOptions>[] = [
    {
      label: t('forms:filters.dateFilter.options.all'),
      value: 'all',
    },
    // {
    //   label: 'Today',
    //   value: 'today',
    // },
    // {
    //   label: 'Yesterday',
    //   value: 'yesterday',
    // },
    // {
    //   label: 'Last week',
    //   value: 'last-week',
    // },
    // {
    //   label: 'Last Month',
    //   value: 'last-month',
    // },
    {
      label: t('forms:filters.dateFilter.options.exactly'),
      value: 'exactly',
    },
    {
      label: t('forms:filters.dateFilter.options.before'),
      value: 'before',
    },
    {
      label: t('forms:filters.dateFilter.options.on-or-before'),
      value: 'on-or-before',
    },
    {
      label: t('forms:filters.dateFilter.options.after'),
      value: 'after',
    },
    {
      label: t('forms:filters.dateFilter.options.on-or-after'),
      value: 'on-or-after',
    },
    {
      label: 'Period',
      value: 'between',
    },
  ];

  const handleValueChange = () => {
    const value: DateFilterValue[] = [];

    if (option === 'between' && selectedPeriod?.from && selectedPeriod?.to) {
      value.push({
        operator: getOperatorFromOption('on-or-after'),
        value: selectedPeriod.from.format('YYYY-MM-DD'),
      });
      value.push({
        operator: getOperatorFromOption('on-or-before'),
        value: selectedPeriod.to.format('YYYY-MM-DD'),
      });
    } else if (selectedDate) {
      value.push({
        operator: getOperatorFromOption(option),
        value: selectedDate.format('YYYY-MM-DD'),
      });
    }

    console.log('change', value);

    onChange(value);
  };

  useEffect(handleValueChange, [selectedDate, selectedPeriod]);

  useEffect(() => {
    if (option === 'all') {
      setSelectedDate(null);
      onChange([]);
    } else if (selectedDate) {
      handleValueChange();
    }
  }, [option]);

  return (
    <Stack>
      <RadioField
        options={options}
        value={option}
        label={label}
        onChange={(value) => {
          setOption(value as DateFilterOptions);
        }}
      />

      {showFromDatePicker && (
        <Fragment>
          <Divider
            sx={{
              mb: '10px',
            }}
          />
          <DatePicker
            label={t(`forms:filters.dateFilter.options.${option}`)}
            onChange={setSelectedDate}
            selectedDate={selectedDate}
            error={false}
            required
          />
        </Fragment>
      )}

      {showPeriodSelector && (
        <Fragment>
          <Divider
            sx={{
              mb: '10px',
            }}
          />
          <PeriodSelector value={selectedPeriod} onChange={setSelectedPeriod} />
        </Fragment>
      )}
    </Stack>
  );
};
